import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Lock, ArrowRight, Calendar, FileText, PenTool, GraduationCap, Calculator, MessageSquareText, LifeBuoy, Sparkles } from 'lucide-react';

/* Admin → Pricing → "Pro Features" rows → a matching icon + the page where the student can use it. */
const MAP = [
  [/live|class|session|q&a/i, Calendar, '/group-classes', 'Group Classes'],
  [/credit|teacher feedback|feedback/i, MessageSquareText, '/feedback-credits', 'Teacher Feedback'],
  [/writing|speaking|score|scoring|instant|real-time/i, PenTool, '/practice/writing', 'Practice'],
  [/mock|exam|practice|test|question/i, FileText, '/exams', 'Mock Exams'],
  [/course|video|lecture|secret/i, GraduationCap, '/courses', 'Courses'],
  [/crs|express entry|pr score|immigration/i, Calculator, '/crs-calculator', 'CRS Calculator'],
  [/support|discord|priority|mentor/i, LifeBuoy, '/contact', 'Contact'],
];
export const featureMeta = (text) => {
  const hit = MAP.find(([re]) => re.test(text));
  return hit ? { Icon: hit[1], to: hit[2], label: hit[3] } : { Icon: Sparkles, to: '', label: '' };
};

/** Checkmarked (Pro) or locked (free) list of everything in Pro, each row linking to where it lives in the app. */
export function IncludedList({ features, isPro, compact = false, dark = false }) {
  return (
    <ul className={compact ? 'space-y-1.5' : 'space-y-2.5'} data-testid="included-list">
      {features.map((f, i) => {
        const { Icon, to, label } = featureMeta(f);
        return (
          <li key={i} className={`flex items-start gap-3 ${compact ? 'text-sm' : 'text-[15px]'}`} data-testid={`included-row-${i}`}>
            <span className={`mt-0.5 w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${isPro ? 'bg-emerald-500 text-white' : dark ? 'bg-white/10 text-white/60' : 'bg-slate-200 text-slate-500'}`}>{isPro ? <Check size={12} strokeWidth={3} /> : <Lock size={11} />}</span>
            <span className={`flex-1 min-w-0 ${dark ? 'text-white/90' : 'text-slate-800'} ${isPro ? '' : dark ? 'text-white/60' : 'text-slate-500'}`}>{f}</span>
            {isPro && to && !compact && (
              <Link to={to} className={`hidden sm:inline-flex items-center gap-1 text-xs font-semibold shrink-0 ${dark ? 'text-emerald-300 hover:text-emerald-200' : 'text-blue-700 hover:underline'}`} data-testid={`included-open-${i}`}><Icon size={12} /> {label} <ArrowRight size={11} /></Link>
            )}
          </li>
        );
      })}
    </ul>
  );
}
